import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertBannerComponent } from './shared/components/alert-banner/alert-banner.component';
import { IaAssistenteComponent } from './shared/components/ia-assistente/ia-assistente.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AlertBannerComponent, IaAssistenteComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'ats-hub-ui';
}
